import { LifestyleTransactionsPageTemplate } from "./template";
import { useLifestyleTransactionsPage } from "./logic";

export const LifestyleTransactionsPage = (): JSX.Element => {
  const templateProps = useLifestyleTransactionsPage();
  return <LifestyleTransactionsPageTemplate {...templateProps} />;
};
